const translations: Record<string, string> = {
  // Genel
  "app.name": "İlkim Butik Otel",
  "app.panel": "Yönetim Paneli",
  "app.location": "Marmaris / Orhaniye / Kız Kumu",

  // Menü
  "menu.dashboard": "Genel Bakış",
  "menu.reservations": "Rezervasyonlar",
  "menu.calendar": "Takvim / Doluluk",
  "menu.customers": "Müşteriler",
  "menu.checkInOut": "Giriş - Çıkış",
  "menu.rooms": "Odalar",
  "menu.payments": "Ödemeler",
  "menu.sources": "Müşteri Kaynakları",
  "menu.offers": "Teklif ve Takip",
  "menu.tasks": "Görevler",
  "menu.reports": "Raporlar",
  "menu.settings": "Ayarlar",

  // Dashboard Kartları
  "dashboard.todayCheckins": "Bugünkü Girişler",
  "dashboard.todayCheckouts": "Bugünkü Çıkışlar",
  "dashboard.stayingGuests": "Konaklayan Misafir",
  "dashboard.emptyRooms": "Boş Oda",
  "dashboard.occupiedRooms": "Dolu Oda",
  "dashboard.pendingReservations": "Bekleyen Rezervasyon",
  "dashboard.depositPending": "Kapora Bekleyen",
  "dashboard.todayCollection": "Bugünkü Tahsilat",
  "dashboard.monthlyRevenue": "Bu Ay Toplam Gelir",
  "dashboard.monthlyOccupancy": "Bu Ay Doluluk",
  "dashboard.adLeads": "Reklamdan Gelen Lead",
  "dashboard.convertedLeads": "Rezervasyona Dönen",

  // Hızlı İşlemler
  "action.newReservation": "Yeni Rezervasyon",
  "action.newCustomer": "Yeni Müşteri",
  "action.quickOffer": "Hızlı Teklif Kaydı",
  "action.addPayment": "Ödeme Ekle",
  "action.checkIn": "Giriş Yapıldı",
  "action.checkOut": "Çıkış Yapıldı",
  "action.sendWhatsApp": "WhatsApp",

  // Genel İfadeler
  "common.search": "Ara",
  "common.filter": "Filtrele",
  "common.all": "Tümü",
  "common.save": "Kaydet",
  "common.cancel": "İptal",
  "common.edit": "Düzenle",
  "common.delete": "Sil",
  "common.detail": "Detay",
  "common.add": "Ekle",
  "common.loading": "Yükleniyor...",
  "common.noData": "Veri bulunamadı",
  "common.total": "Toplam",
  "common.status": "Durum",
  "common.date": "Tarih",
  "common.amount": "Tutar",
  "common.phone": "Telefon",
  "common.name": "Ad Soyad",
  "common.room": "Oda",
  "common.source": "Kaynak",
  "common.actions": "İşlemler",
  "common.note": "Not",

  // Rezervasyon
  "reservation.number": "Rezervasyon No",
  "reservation.checkIn": "Giriş Tarihi",
  "reservation.checkOut": "Çıkış Tarihi",
  "reservation.nights": "Gece",
  "reservation.guests": "Kişi",
  "reservation.roomType": "Oda Tipi",
  "reservation.roomNo": "Oda No",
  "reservation.totalAmount": "Toplam Tutar",
  "reservation.deposit": "Kapora",
  "reservation.remaining": "Kalan",
  "reservation.status": "Rezervasyon Durumu",
  "reservation.paymentStatus": "Ödeme Durumu",

  // Müşteri
  "customer.city": "Şehir",
  "customer.totalStays": "Toplam Konaklama",
  "customer.lastStay": "Son Konaklama",
  "customer.totalSpent": "Toplam Harcama",
  "customer.tags": "Etiketler",
};

export default translations;